export default __webpack_public_path__ + "static/media/WHO-color.cd5055ee.png";